/*
  Tablya : page collection (chargé en defer par sections/main-collection-product-grid.liquid).
  1. Colonne de filtres masquable sur ordinateur (bouton « Masquer les filtres » de la barre d'outils).
     Sur téléphone, c'est le tiroir Dawn qui s'ouvre : rien à faire ici.
  2. Nombre de produits de l'en-tête de collection (sections/tablya-collection-hero.liquid) :
     suit les filtres, en recopiant le nombre que Dawn (facets.js) met à jour dans #ProductCount.
  3. « Voir plus » : ajoute la page suivante à la grille au lieu de changer de page.
     Sans JavaScript, le bouton reste un lien vers la page suivante (lisible par Google).
  La logique Dawn des filtres (facets.js) n'est pas modifiée.
*/
(function () {
  'use strict';

  // Chargé une seule fois, même si la section est présente deux fois
  if (window.TablyaCollection) return;
  window.TablyaCollection = true;

  // ---------- 1. Colonne de filtres masquable ----------
  var CLE_MEMOIRE = 'tb-filtres-masques';

  function lireMemoire() {
    try {
      return window.sessionStorage.getItem(CLE_MEMOIRE) === '1';
    } catch (e) {
      return false;
    }
  }

  function ecrireMemoire(masque) {
    try {
      if (masque) window.sessionStorage.setItem(CLE_MEMOIRE, '1');
      else window.sessionStorage.removeItem(CLE_MEMOIRE);
    } catch (e) {
      /* stockage indisponible : on garde simplement l'état de la page */
    }
  }

  function appliquerBascule(bouton, masque) {
    var vitrine = document.querySelector('[data-tb-vitrine]');
    if (!vitrine || !bouton) return;
    vitrine.classList.toggle('tb-sans-filtres', masque);
    bouton.setAttribute('aria-expanded', masque ? 'false' : 'true');
    var texte = bouton.querySelector('[data-tb-bascule-texte]');
    if (texte) texte.textContent = masque ? bouton.dataset.afficher : bouton.dataset.masquer;
  }

  function initBascule() {
    var bouton = document.querySelector('[data-tb-bascule]');
    if (bouton && lireMemoire()) appliquerBascule(bouton, true);
  }

  document.addEventListener('click', function (event) {
    var bouton = event.target.closest('[data-tb-bascule]');
    if (!bouton) return;
    var masque = bouton.getAttribute('aria-expanded') === 'true';
    appliquerBascule(bouton, masque);
    ecrireMemoire(masque);
  });

  // ---------- 2. Nombre de produits de l'en-tête ----------
  function majNombre() {
    var source = document.getElementById('ProductCount');
    if (!source) return;
    var n = parseInt(source.dataset.productCount, 10);
    if (isNaN(n)) return;
    document.querySelectorAll('[data-tb-nb-produits]').forEach(function (cible) {
      var mot = n > 1 ? cible.dataset.pluriel : cible.dataset.singulier;
      cible.textContent = n + ' ' + mot;
    });
  }

  var observateurNombre = null;

  function initNombre() {
    var source = document.getElementById('ProductCount');
    if (!source || !('MutationObserver' in window)) return;
    if (observateurNombre) observateurNombre.disconnect();
    observateurNombre = new MutationObserver(majNombre);
    observateurNombre.observe(source, { attributes: true, attributeFilter: ['data-product-count'] });
  }

  // ---------- 3. « Voir plus » ----------
  function nettoyerUrl(href) {
    var url = new URL(href, window.location.href);
    url.searchParams.delete('section_id');
    return url.pathname + url.search;
  }

  function voirPlus(lien) {
    var grille = document.getElementById('product-grid');
    var suite = lien.closest('[data-tb-suite]');
    if (!grille || !grille.dataset.id || !suite) {
      window.location.href = lien.href;
      return;
    }

    var url = new URL(lien.href, window.location.href);
    url.searchParams.set('section_id', grille.dataset.id);

    lien.setAttribute('aria-disabled', 'true');
    lien.setAttribute('aria-busy', 'true');
    lien.classList.add('tb-suite__plus--attente');

    fetch(url.toString())
      .then(function (reponse) {
        if (!reponse.ok) throw new Error('HTTP ' + reponse.status);
        return reponse.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nouveaux = doc.querySelectorAll('#product-grid > li');
        var premier = null;

        nouveaux.forEach(function (item) {
          var copie = document.importNode(item, true);
          grille.appendChild(copie);
          if (!premier) premier = copie;
        });

        var suiteNouvelle = doc.querySelector('[data-tb-suite]');
        var texte = suite.querySelector('[data-tb-suite-texte]');
        var jauge = suite.querySelector('[data-tb-suite-jauge]');
        var texteNouveau = suiteNouvelle && suiteNouvelle.querySelector('[data-tb-suite-texte]');
        var jaugeNouvelle = suiteNouvelle && suiteNouvelle.querySelector('[data-tb-suite-jauge]');
        var lienNouveau = suiteNouvelle && suiteNouvelle.querySelector('[data-tb-voir-plus]');

        if (texte && texteNouveau) texte.textContent = texteNouveau.textContent.trim();
        if (jauge && jaugeNouvelle) jauge.style.width = jaugeNouvelle.style.width;

        if (lienNouveau) {
          lien.href = nettoyerUrl(lienNouveau.getAttribute('href'));
          lien.removeAttribute('aria-disabled');
          lien.removeAttribute('aria-busy');
          lien.classList.remove('tb-suite__plus--attente');
        } else {
          lien.remove();
        }

        // Clavier et lecteur d'écran : on se place sur le premier produit ajouté
        // (premier lien visible : la carte Dawn contient aussi un titre masqué)
        if (premier) {
          var liens = premier.querySelectorAll('a[href]');
          for (var i = 0; i < liens.length; i++) {
            if (liens[i].getClientRects().length) {
              liens[i].focus();
              break;
            }
          }
        }
      })
      .catch(function () {
        // En cas d'échec, on retombe sur la navigation classique vers la page suivante
        window.location.href = nettoyerUrl(lien.href);
      });
  }

  document.addEventListener('click', function (event) {
    var lien = event.target.closest('[data-tb-voir-plus]');
    if (!lien) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
    if (!window.fetch || !window.DOMParser) return;
    event.preventDefault();
    if (lien.getAttribute('aria-disabled') === 'true') return;
    voirPlus(lien);
  });

  // ---------- Démarrage ----------
  function init() {
    initBascule();
    initNombre();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Éditeur de thème : une section rechargée repart de zéro
  document.addEventListener('shopify:section:load', init);
})();
